import { createRoot } from 'react-dom/client';
import LeadsForm from 'src/widgets/activities/leads-form/LeadsForm';
import BilberryCustomElement from 'src/widgets/BilberryCustomElement';
import { WidgetWrapper } from 'src/widgets/WidgetWrapper';
import { getYesAttribute } from '@repo/widget-utils/attributes/attribute-helper';
import { UserTextCustomizations } from '@repo/types';

class BilberryLeadsForm extends BilberryCustomElement {
    protected renderWidget(): void {
        const commentPlaceholderTextCustomizationKey = this.getAttribute(
            'comment-placeholder-text-customization-key',
        ) as keyof UserTextCustomizations;
        const hideRequestDate = getYesAttribute(this, 'hide-request-date');
        const hideQuantityPicker = getYesAttribute(this, 'hide-quantity-picker');
        const timeDateSelection = this.getAttribute('time-date-selection') || 'date-range';

        createRoot(this._mountPoint).render(
            <WidgetWrapper
                mountPoint={this._mountPoint}
                popoverMountPoint={this._popoverMountPoint}
                shadowRoot={this._shadowRoot}
            >
                <LeadsForm
                    commentPlaceholderTextCustomizationKey={
                        commentPlaceholderTextCustomizationKey ?? undefined
                    }
                    hideRequestDate={hideRequestDate}
                    hideQuantityPicker={hideQuantityPicker}
                    timeDateSelection={timeDateSelection}
                />
            </WidgetWrapper>,
        );
    }
}

export default function defineCustomElement(): void {
    customElements.define('bilberry-leads-form', BilberryLeadsForm);
}
